import { useState, useEffect, useRef } from 'react';
import { notificationAPI } from '../utils/api';

const overlay = { position:'fixed',inset:0,zIndex:9998 };
const dropdown = { position:'absolute',right:0,top:'100%',marginTop:8,width:360,maxHeight:400,overflow:'auto',background:'#fff',borderRadius:12,boxShadow:'0 8px 30px rgba(0,0,0,0.15)',border:'1px solid #E5E7EB',zIndex:9999 };

const moduleBadge = (mod) => {
  const map = { binkar:'#3B82F6', tahor:'#8B5CF6', pensiun:'#EF4444', personel:'#10B981' };
  return <span style={{ padding:'1px 6px',borderRadius:4,fontSize:9,fontWeight:700,color:'#fff',background:map[mod]||'#6B7280',textTransform:'uppercase' }}>{mod}</span>;
};

export default function NotificationBell() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [unread, setUnread] = useState(0);
  const ref = useRef(null);

  const load = async () => {
    try {
      const r = await notificationAPI.getAll();
      setData(r.data || []);
      setUnread(r.unread || 0);
    } catch {}
  };

  useEffect(() => {
    load();
    const iv = setInterval(load, 60000);
    return () => clearInterval(iv);
  }, []);

  const handleMarkRead = async (id) => {
    try { await notificationAPI.markRead(id); load(); } catch {}
  };

  const handleMarkAll = async () => {
    try { await notificationAPI.markAllRead(); load(); } catch {}
  };

  return (
    <div style={{ position:'relative' }} ref={ref}>
      <button onClick={() => { setOpen(!open); if (!open) load(); }}
        style={{ position:'relative',background:'none',border:'none',cursor:'pointer',padding:8,borderRadius:8,display:'flex',alignItems:'center' }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
        </svg>
        {unread > 0 && <span style={{ position:'absolute',top:4,right:4,width:16,height:16,borderRadius:'50%',background:'#EF4444',color:'#fff',fontSize:9,fontWeight:700,display:'flex',alignItems:'center',justifyContent:'center' }}>{unread > 9 ? '9+' : unread}</span>}
      </button>

      {open && <>
        <div style={overlay} onClick={() => setOpen(false)} />
        <div style={dropdown}>
          <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 16px',borderBottom:'1px solid #F3F4F6' }}>
            <span style={{ fontSize:14,fontWeight:700,color:'#111827' }}>Notifikasi</span>
            {unread > 0 && <button onClick={handleMarkAll} style={{ background:'none',border:'none',color:'#2563EB',fontSize:12,cursor:'pointer',fontFamily:'inherit' }}>Tandai semua dibaca</button>}
          </div>
          {data.length === 0 ? (
            <div style={{ padding:30,textAlign:'center',color:'#9CA3AF',fontSize:13 }}>Tidak ada notifikasi</div>
          ) : data.map(n => (
            <div key={n.id} onClick={() => { if (!n.is_read) handleMarkRead(n.id); }}
              style={{ padding:'10px 16px',borderBottom:'1px solid #F9FAFB',background:n.is_read?'#fff':'#F0F9FF',cursor:'pointer',transition:'background 0.15s' }}>
              <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:4 }}>
                {moduleBadge(n.module)}
                <span style={{ fontSize:10,color:'#9CA3AF' }}>{new Date(n.created_at).toLocaleString('id-ID', { day:'2-digit',month:'short',hour:'2-digit',minute:'2-digit' })}</span>
              </div>
              <div style={{ fontSize:13,fontWeight:n.is_read?400:600,color:'#111827' }}>{n.title}</div>
              {n.message && <div style={{ fontSize:11,color:'#6B7280',marginTop:2 }}>{n.message}</div>}
            </div>
          ))}
        </div>
      </>}
    </div>
  );
}
